import { Routes } from '@angular/router';
import { authGuard } from "../../_shared/helpers";
import { ConfirmationUpdateComponent } from "./confirmation-update/confirmation-update.component";
import { ConfirmationDetailsComponent } from "./confirmation-details/confirmation-details.component";

export const CONFIRMATION_ROUTES: Routes = [
  {
    path: 'confirmation/details/:projid/:jobid/:confid',
    component: ConfirmationDetailsComponent,
    canActivate: [authGuard]
  },
  {
    path: 'confirmation/update/:projid/:jobid/:confid',
    component: ConfirmationUpdateComponent,
    canActivate: [authGuard]
  }
]
